import React from 'react';
import './StarlinkCTA.scss';

const StarlinkCTA: React.FC = () => {
  const handleRequestQuote = () => {
    window.location.href = 'mailto:sales@shadowtracker.com?subject=Starlink Fleet Quote Request';
  };

  const handleScheduleDemo = () => {
    window.location.href = 'tel:+1234567890';
  };

  return (
    <section className="starlink-cta">
      <div className="container">
        <div className="cta-card">
          <div className="cta-icon">🚀</div>
          <h2>Ready to Transform Your Fleet?</h2>
          <p className="cta-description">
            Join hundreds of businesses using Starlink for professional fleet management. 
            Get a custom quote tailored to your fleet size and requirements.
          </p>
          
          <div className="cta-buttons">
            <button className="btn-primary" onClick={handleRequestQuote}>
              Request Custom Quote
              <span className="arrow">→</span>
            </button>
            <button className="btn-secondary" onClick={handleScheduleDemo}>
              Schedule Demo
            </button>
          </div>

          <div className="cta-guarantee">
            <span className="guarantee-icon">✓</span>
            <span>Professional installation • 24/7 support • Enterprise-grade security</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StarlinkCTA;
